import { IonButton, IonButtons, IonCheckbox, IonContent, IonFooter, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonList, IonLoading, IonSegment, IonSegmentButton, IonSelect, IonSelectOption, IonTitle, IonToast, IonToolbar } from '@ionic/react';
import { arrowBack, locationOutline, searchOutline, storefrontOutline } from 'ionicons/icons';
import * as Leaflet from 'leaflet';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { MessageContext } from '../../../contexts/MessageContext';
import {
  buscarDetalhesLocalizacao,
  buscarPlaceDetails,
  buscarPlaces,
  buscarSugestoesLocalizacao,
  requestService
} from '../../../Utils/Services';
import './Endereco.css';

type Props = {
  endereco: any;
  inputRef: any;
  closeAction: Function;
  closeActionSimple: Function;
  modoDescoberta?: boolean;
}

const Endereco: React.FC<Props> = (props: Props) => {

  const history = useHistory();
  const location = useLocation<any>();
  const modoDescoberta = props.modoDescoberta === true;

  const { dadosEmpresa, setDadosEmpresa } = useContext(MessageContext);

  const [enderecoSelecionado, setEnderecoSelecionado] = useState<any>();

  const [rua, setRua] = useState<any>();
  const [complemento, setComplemento] = useState<any>();

  const [textToast, setTextToast] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [showLoading, setShowLoading] = useState(false);

  const [latitudeSelecionado, setLatitudeSelecionado] = useState('');
  const [longitudeSelecionado, setLongitudeSelecionado] = useState('');

  const [taxaEntregaSelecionado, setTaxaEntregaSelecionado] = useState('');
  const [tempoEntregaSelecionado, setTempoEntregaSelecionado] = useState('');

  const [exibirEndereco, setExibirEndereco] = useState(false);

  const mapRef = useRef<any>(null);
  const markerRef = useRef<any>(null);
  const [mapState, setMapState] = useState<any>(null);
  const [localizacaoState, setLocalizacaoState] = useState<any>(null);

  const [listaEnderecos, setListaEnderecos] = useState<any>([]);
  const [searchTimeout, setSearchTimeout] = useState<any>(null);
  const [ultimaBuscaRealizada, setUltimaBuscaRealizada] = useState('');

  // Estados para controlar o fluxo de entrada de endereço
  const [etapaEndereco, setEtapaEndereco] = useState<'busca' | 'numero' | 'mapa' | 'complemento' | 'enderecoManual'>('busca');
  const [numeroEndereco, setNumeroEndereco] = useState('');
  const [enderecoSemNumero, setEnderecoSemNumero] = useState(false);
  const [enderecoSemComplemento, setEnderecoSemComplemento] = useState(false);
  const [placeIdSelecionado, setPlaceIdSelecionado] = useState('');
  const [descricaoEnderecoSelecionado, setDescricaoEnderecoSelecionado] = useState('');
  const [pulouEtapaNumero, setPulouEtapaNumero] = useState(false);
  const [enderecoManual, setEnderecoManual] = useState('');
  const [numeroManual, setNumeroManual] = useState('');

  const [deliveryMetodo, setDeliveryMetodo] = useState('delivery');
  const [bairroSelecionado, setBairroSelecionado] = useState('');
  const [enderecoBairro, setEnderecoBairro] = useState('');
  const [complementoBairro, setComplementoBairro] = useState('');
  const [numeroBairro, setNumeroBairro] = useState('');
  const [enderecoSemNumeroBairro, setEnderecoSemNumeroBairro] = useState(false);

  const myIcon = new Leaflet.Icon({
    iconUrl: '/assets/pin.svg',
    iconSize: [40, 40],
    popupAnchor: [0, -20]
  });

  useEffect(() => {
    if (props.inputRef.current) {
      props.inputRef.current.focus();
    }
  }, [props.inputRef]);

  useEffect(() => {

    if (modoDescoberta) {
      const timer = setTimeout(() => loadMap(), 500);
      return () => clearTimeout(timer);
    }

    console.log("dadosEmpresa.configuracoesEntrega", dadosEmpresa.configuracoesEntrega);

    const temDelivery = dadosEmpresa.configuracoesEntrega && dadosEmpresa.configuracoesEntrega.length > 0;
    const temRetirada = dadosEmpresa.retirada === true;

    // Se não tem nenhuma opção disponível, fechar o modal
    if (!temDelivery && !temRetirada) {
      setTextToast("No momento não estamos aceitando pedidos. Entre em contato com o estabelecimento.");
      setShowToast(true);
      setTimeout(() => {
        props.closeActionSimple();
      }, 2000);
      return;
    }

    // Se não tem delivery mas tem retirada, definir retirada como padrão
    if (!temDelivery && temRetirada) {
      setDeliveryMetodo("retirada");
      // setTextToast("No momento estamos trabalhando com somente a opção de retirada.");
      // setShowToast(true);
    }

    const timer = setTimeout(() => {
      loadMap();
    }, 500);

    return () => clearTimeout(timer); // Limpeza do timer
  }, []);


  function cadastrar() {
    // Validação: se não marcou "sem complemento" e não preencheu o campo
    if (!enderecoSemComplemento && (!complemento || complemento.trim() === '')) {
      setTextToast('Por favor, informe o complemento ou marque "Endereço sem complemento".');
      setShowToast(true);
      return;
    }

    console.log("enderecoSelecionado");
    console.log("latitudeSelecionado");
    console.log("longitudeSelecionado");
    console.log("taxaEntregaSelecionado");

    if (modoDescoberta) {
      if (!enderecoSelecionado || !latitudeSelecionado || !longitudeSelecionado) {
        setTextToast('Selecione um local para continuar.');
        setShowToast(true);
        return;
      }

      props.closeAction(
        enderecoSelecionado,
        latitudeSelecionado,
        longitudeSelecionado,
        '',
        '',
        complemento || ''
      );
      return;
    }

    // Validação para delivery por bairro
    if (dadosEmpresa.tipoConfiguracoesEntrega === "bairro" && deliveryMetodo === "delivery") {
      if (!enderecoBairro.trim()) {
        setTextToast("Endereço é obrigatório.");
        setShowToast(true);
        return;
      }
      if (!bairroSelecionado) {
        setTextToast("Selecione um bairro.");
        setShowToast(true);
        return;
      }

      // Buscar a taxa do bairro selecionado
      const bairroConfig = dadosEmpresa.configuracoesEntrega?.find((config: any) => config.bairro === bairroSelecionado);
      if (bairroConfig) {
        props.closeAction(enderecoBairro, "", "", bairroConfig.taxa, bairroConfig.tempo || "", complementoBairro);
      } else {
        setTextToast("Bairro não encontrado na configuração.");
        setShowToast(true);
      }
      return;
    }

    // Validação para delivery por raio (comportamento atual)
    if (!taxaEntregaSelecionado) {
      setTextToast("Fora da área de entrega.");
      setShowToast(true);
    }
    else if (!enderecoSelecionado || !latitudeSelecionado || !longitudeSelecionado) {
      setTextToast('Selecione um local para continuar.');
      setShowToast(true);
    }
    else {
      props.closeAction(enderecoSelecionado, latitudeSelecionado, longitudeSelecionado, taxaEntregaSelecionado, tempoEntregaSelecionado, complemento);
    }


  }

  function loadMap() {
    try {
      const map = Leaflet.map('map', {
        zoomControl: false,
        scrollWheelZoom: 'center', // Zoom sempre no centro
        doubleClickZoom: 'center',
        touchZoom: 'center'
      }).fitWorld();

      Leaflet.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 18,
        attribution: '© OpenStreetMap'
      }).addTo(map);

      Leaflet.control.zoom({
        position: 'bottomright'
      }).addTo(map);

      map.on('locationerror', () => {
        console.log('Erro ao obter localização');
      });

      // Função para atualizar coordenadas baseado no centro do mapa
      const atualizarCoordenadas = () => {
        const center = map.getCenter();
        console.log('Centro do mapa:', center.lat, center.lng);
        setLatitudeSelecionado(center.lat.toString());
        setLongitudeSelecionado(center.lng.toString());

        if (modoDescoberta) return;

        // Calcular distância e taxa de entrega
        const empresaLat = parseFloat(dadosEmpresa.empresaLatitude || "0");
        const empresaLng = parseFloat(dadosEmpresa.empresaLongitude || "0");
        const distanciaKm = map.distance([empresaLat, empresaLng], [center.lat, center.lng]) / 1000;

        // Buscar configuração de entrega baseada na distância
        const configEntrega = dadosEmpresa.configuracoesEntrega?.find((config: any) => {
          const raioKm = parseFloat(config.raio || "0");
          return distanciaKm <= raioKm;
        });

        if (configEntrega) {
          setTaxaEntregaSelecionado(configEntrega.taxa || "0,00");
          setTempoEntregaSelecionado(configEntrega.tempo || "");
        } else {
          setTaxaEntregaSelecionado("");
          setTempoEntregaSelecionado("");
        }
      };

      // Adicionar eventos para capturar mudanças no mapa
      map.on('moveend', atualizarCoordenadas);
      map.on('zoomend', atualizarCoordenadas);
      map.on('dragend', atualizarCoordenadas);

      mapRef.current = map;
      setMapState(map);

    } catch (e: any) {
      console.log("Erro ao carregar mapa: " + e.message);
    }
  }

  function onLocationError(e: any) {
    console.error("Erro ao obter localização:", e.message);
  }


  function buscarSugestoesEndereco(endereco: string, forceBusca: boolean = false) {
    if (endereco.trim() === "") {
      setListaEnderecos([]);
      setUltimaBuscaRealizada('');
      return;
    }

    // Verificar se tem no mínimo 4 caracteres
    if (endereco.trim().length < 4) {
      setListaEnderecos([]);
      return;
    }

    // Verificar se já foi feita busca com esse texto
    if (!forceBusca && endereco.trim() === ultimaBuscaRealizada) {
      return;
    }

    // Limpar timeout anterior para evitar muitas chamadas
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    // Criar novo timeout para buscar após 2000ms sem digitação (apenas se não for busca forçada)
    const timeout = setTimeout(() => {
      const enderecoTratado = endereco.toLowerCase().replace(/\s/g, "%20");

      let urlCompleta;

      if (modoDescoberta) {
        urlCompleta = buscarSugestoesLocalizacao.url.replace('{texto}', enderecoTratado);
      } else {
        let empresaid = localStorage.getItem("empresaid") || "";

        // ✅ Prioriza o contexto sobre o localStorage
        if (dadosEmpresa?.pk) {
          empresaid = dadosEmpresa.pk;
          console.log("🔄 buscarSugestoesEndereco - Usando empresaid do contexto:", empresaid);
        }

        urlCompleta = buscarPlaces.url
          .replace("{id}", empresaid.replace(/#/g, '%23'))
          .replace("{endereco}", enderecoTratado);
      }

      setShowLoading(true);

      requestService(
        urlCompleta,
        {
          method: modoDescoberta ? buscarSugestoesLocalizacao.method : buscarPlaces.method,
          headers: [["token", window.localStorage.getItem("token")]],
          credentials: 'include'
        },
        history,
        (response: any) => {
          if (response && response.sucesso && response.sugestoes) {
            setListaEnderecos(response.sugestoes);
            setUltimaBuscaRealizada(endereco.trim());
          }
        },
        (error: any) => {
          console.log("Erro ao buscar sugestões:", error);
          setTextToast("Erro ao buscar endereços. Tente novamente.");
          setShowToast(true);
        }
      ).finally(() => {
        setShowLoading(false);
      });
    }, forceBusca ? 0 : 2000);

    setSearchTimeout(timeout);
  }

  function buscarDetalhesEndereco(placeId: string, enderecoFormatado: string) {
    let urlCompleta;

    if (modoDescoberta) {
      urlCompleta = buscarDetalhesLocalizacao.url.replace('{placeId}', encodeURIComponent(placeId));
    } else {
      let empresaid = localStorage.getItem("empresaid") || "";

      // ✅ Prioriza o contexto sobre o localStorage
      if (dadosEmpresa?.pk) {
        empresaid = dadosEmpresa.pk;
        console.log("🔄 buscarDetalhesEndereco - Usando empresaid do contexto:", empresaid);
      }

      urlCompleta = buscarPlaceDetails.url
        .replace("{id}", empresaid.replace(/#/g, '%23'))
        .replace("{placeId}", placeId);
    }

    setShowLoading(true);

    requestService(
      urlCompleta,
      {
        method: modoDescoberta ? buscarDetalhesLocalizacao.method : buscarPlaceDetails.method,
        headers: [["token", window.localStorage.getItem("token")]],
        credentials: 'include'
      },
      history,
      (response: any) => {
        if (response && response.sucesso) {
          setEnderecoSelecionado(enderecoFormatado);
          setLatitudeSelecionado(response.latitude.toString());
          setLongitudeSelecionado(response.longitude.toString());

          // Verificar se está dentro da área de entrega
          if (response.distancia) {
            // Buscar configuração de entrega baseada na distância
            const configEntrega = dadosEmpresa.configuracoesEntrega?.find((config: any) => {
              const raioKm = parseFloat(config.raio || "0");
              return response.distancia.km <= raioKm;
            });

            if (configEntrega) {
              setTaxaEntregaSelecionado(configEntrega.taxa || "0,00");
              setTempoEntregaSelecionado(configEntrega.tempo || "");
            } else {
              setTaxaEntregaSelecionado("");
              setTempoEntregaSelecionado("");
              setTextToast("Fora da área de entrega.");
              setShowToast(true);
            }
          }

          const lat = Number(response.latitude);
          const lng = Number(response.longitude);
          const novaLocalizacao = Leaflet.latLng(lat, lng);

          setTextToast("Endereço localizado com sucesso.");
          setShowToast(true);
          setExibirEndereco(true);
          setListaEnderecos([]);

          setLocalizacaoState({ lat, lng });

          if (mapRef.current) {
            mapRef.current.setView(novaLocalizacao, 14);
          }
        }
      },
      (error: any) => {
        console.log("Erro ao buscar detalhes:", error);
        setTextToast(error.message || "Erro ao localizar endereço.");
        setShowToast(true);
      }
    ).finally(() => {
      setShowLoading(false);
    });
  }

  const handleSelectItem = (item: any) => {
    try {
      console.log("item selecionado", item);

      // Salvar placeId e descrição para usar depois
      setPlaceIdSelecionado(item.placeId);
      setDescricaoEnderecoSelecionado(item.descricao);
      setListaEnderecos([]);

      // Verificar se o endereço já tem número nos termos
      const temNumero = item.termos?.some((termo: string) => /^\d+$/.test(termo));

      if (temNumero) {
        // Se já tem número, extrair e ir direto para o mapa
        const numero = item.termos.find((termo: string) => /^\d+$/.test(termo));
        setNumeroEndereco(numero);
        setPulouEtapaNumero(true); // Marcando que pulou a etapa de número
        setEtapaEndereco('mapa');
        buscarDetalhesEnderecoComNumero(item.placeId, item.descricao, numero);
      } else {
        // Se não tem número, ir para a etapa de pedir o número
        setPulouEtapaNumero(false);
        setEtapaEndereco('numero');
      }
    } catch (error) {
      console.log("erro ao selecionar item", error);
    }
  };

  const buscarDetalhesEnderecoComNumero = (placeId: string, enderecoFormatado: string, numero: string) => {
    let urlCompleta;

    if (modoDescoberta) {
      urlCompleta = buscarDetalhesLocalizacao.url.replace('{placeId}', encodeURIComponent(placeId));
    } else {
      let empresaid = localStorage.getItem("empresaid") || "";

      // ✅ Prioriza o contexto sobre o localStorage
      if (dadosEmpresa?.pk) {
        empresaid = dadosEmpresa.pk;
        console.log("🔄 buscarDetalhesEnderecoComNumero - Usando empresaid do contexto:", empresaid);
      }

      urlCompleta = buscarPlaceDetails.url
        .replace("{id}", empresaid.replace(/#/g, '%23'))
        .replace("{placeId}", placeId);
    }

    setShowLoading(true);

    requestService(
      urlCompleta,
      {
        method: modoDescoberta ? buscarDetalhesLocalizacao.method : buscarPlaceDetails.method,
        headers: [["token", window.localStorage.getItem("token")]],
        credentials: 'include'
      },
      history,
      (response: any) => {
        if (response && response.sucesso) {
          // Verificar se o endereço já contém o número
          const enderecoJaTemNumero = enderecoFormatado.match(/,\s*\d+/);

          let enderecoCompleto;
          if (enderecoSemNumero) {
            // Se é sem número, usar endereço como está
            enderecoCompleto = enderecoFormatado;
          } else if (enderecoJaTemNumero) {
            // Se já tem número na descrição, usar como está
            enderecoCompleto = enderecoFormatado;
          } else {
            // Se não tem número, adicionar após a vírgula
            enderecoCompleto = enderecoFormatado.replace(/,/, `, ${numero} -`);
          }

          setEnderecoSelecionado(enderecoCompleto);
          setLatitudeSelecionado(response.latitude.toString());
          setLongitudeSelecionado(response.longitude.toString());

          // Verificar se está dentro da área de entrega
          if (!modoDescoberta && response.distancia) {
            const configEntrega = dadosEmpresa.configuracoesEntrega?.find((config: any) => {
              const raioKm = parseFloat(config.raio || "0");
              return response.distancia.km <= raioKm;
            });

            if (configEntrega) {
              setTaxaEntregaSelecionado(configEntrega.taxa || "0,00");
              setTempoEntregaSelecionado(configEntrega.tempo || "");
            } else {
              setTaxaEntregaSelecionado("");
              setTempoEntregaSelecionado("");
              setTextToast("Fora da área de entrega.");
              setShowToast(true);
              return;
            }
          }

          const lat = Number(response.latitude);
          const lng = Number(response.longitude);
          const novaLocalizacao = Leaflet.latLng(lat, lng);

          setLocalizacaoState({ lat, lng });

          if (mapRef.current) {
            mapRef.current.setView(novaLocalizacao, 16);
          }

          // setTextToast("Endereço localizado com sucesso.");
          // setShowToast(true);
        }
      },
      (error: any) => {
        console.log("Erro ao buscar detalhes:", error);
        setTextToast(error.message || "Erro ao localizar endereço.");
        setShowToast(true);
      }
    ).finally(() => {
      setShowLoading(false);
    });
  };

  const confirmarNumero = () => {
    if (!enderecoSemNumero && (!numeroEndereco || numeroEndereco.trim() === '')) {
      setTextToast('Por favor, informe o número ou marque "Endereço sem número".');
      setShowToast(true);
      return;
    }

    setPulouEtapaNumero(false); // Não pulou, passou pela etapa de número
    setEtapaEndereco('mapa');
    buscarDetalhesEnderecoComNumero(placeIdSelecionado, descricaoEnderecoSelecionado, numeroEndereco);
  };

  const confirmarLocalizacao = () => {
    // Validação: verificar se está dentro da área de entrega
    if (!modoDescoberta && !taxaEntregaSelecionado) {
      setTextToast("Fora da área de entrega.");
      setShowToast(true);
      return;
    }

    if (!enderecoSelecionado || !latitudeSelecionado || !longitudeSelecionado) {
      setTextToast('Selecione um local para continuar.');
      setShowToast(true);
      return;
    }

    setEtapaEndereco('complemento');
  };

  const voltarParaBusca = () => {
    setEtapaEndereco('busca');
    setNumeroEndereco('');
    setEnderecoSemNumero(false);
    setEnderecoSemComplemento(false);
    setComplemento('');
    setPlaceIdSelecionado('');
    setDescricaoEnderecoSelecionado('');
    setRua('');
    setListaEnderecos([]);
    setUltimaBuscaRealizada('');
    setPulouEtapaNumero(false);
    setEnderecoManual('');
    setNumeroManual('');
  };

  const handleDeliveryMetodoChange = (value: any) => {
    setDeliveryMetodo(value);
  };

  const handleVoltar = () => {
    if (etapaEndereco === 'enderecoManual') {
      // Voltar para busca
      setEtapaEndereco('busca');
      setEnderecoManual('');
      setNumeroManual('');
      setPulouEtapaNumero(false);
    } else if (etapaEndereco === 'numero') {
      // Voltar para busca
      setEtapaEndereco('busca');
      setNumeroEndereco('');
      setEnderecoSemNumero(false);
      setPulouEtapaNumero(false);
    } else if (etapaEndereco === 'mapa') {
      // Se pulou a etapa de número (veio direto da busca ou endereço manual), voltar para busca
      if (pulouEtapaNumero) {
        setEtapaEndereco('busca');
      } else {
        // Se passou pela etapa de número, voltar para número
        setEtapaEndereco('numero');
      }
    } else if (etapaEndereco === 'complemento') {
      // Voltar para mapa
      setEtapaEndereco('mapa');
    } else {
      // Se está na busca, fechar o modal
      props.closeActionSimple();
    }
  };

  const confirmarEnderecoManual = () => {
    if (!enderecoManual.trim()) {
      setTextToast('Por favor, informe o endereço.');
      setShowToast(true);
      return;
    }

    if (!enderecoSemNumero && !numeroManual.trim()) {
      setTextToast('Por favor, informe o número ou marque "Endereço sem número".');
      setShowToast(true);
      return;
    }

    const descricao = enderecoSemNumero
      ? enderecoManual
      : `${enderecoManual}, ${numeroManual}`;

    const abrirMapa = (latitude: string, longitude: string) => {
      setDescricaoEnderecoSelecionado(descricao);
      setEnderecoSelecionado(descricao);
      setLatitudeSelecionado(latitude);
      setLongitudeSelecionado(longitude);
      setTaxaEntregaSelecionado("");
      setTempoEntregaSelecionado("");
      setPulouEtapaNumero(true);
      setEtapaEndereco('mapa');

      setTimeout(() => {
        if (mapState && latitude && longitude) {
          mapState.setView(Leaflet.latLng(parseFloat(latitude), parseFloat(longitude)), 16);
        }
      }, 500);
    };

    if (modoDescoberta) {
      if (!navigator.geolocation) {
        setTextToast('Não foi possível obter uma posição inicial para o mapa.');
        setShowToast(true);
        return;
      }

      setShowLoading(true);
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setShowLoading(false);
          abrirMapa(position.coords.latitude.toString(), position.coords.longitude.toString());
        },
        () => {
          setShowLoading(false);
          setTextToast('Ative a localização para ajustar um endereço não encontrado no mapa.');
          setShowToast(true);
        },
        { enableHighAccuracy: false, maximumAge: 300000, timeout: 8000 }
      );
      return;
    }

    // No pedido, o mapa manual continua iniciando nas coordenadas da empresa.
    const latEmpresa = dadosEmpresa.empresaLatitude || '';
    const lngEmpresa = dadosEmpresa.empresaLongitude || '';
    if (!latEmpresa || !lngEmpresa) {
      setTextToast('Coordenadas da empresa não disponíveis.');
      setShowToast(true);
      return;
    }

    abrirMapa(latEmpresa, lngEmpresa);
  };

  return (
    <>

      <IonHeader className="ion-no-border">
        <IonToolbar className="pedido-fluxo-modal-toolbar">
          <IonButtons slot="start" className="pedido-fluxo-back-buttons">
            <IonButton className="pedido-fluxo-back-button" fill="clear" onClick={handleVoltar}>
              <IonIcon icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>Endereço</IonTitle>

        </IonToolbar>


      </IonHeader>
      <IonContent className={"Mapa"}>

        <div style={{ position: 'absolute', zIndex: 999, backgroundColor: 'white', width: '100%', height: "auto" }}>

          {/* ETAPA 1: BUSCA DE ENDEREÇO */}
          {etapaEndereco === 'busca' && (
            <>
              {!modoDescoberta && (
                <IonToolbar style={{ height: "48px" }}>
                  <IonSegment value={deliveryMetodo} onIonChange={(e) => handleDeliveryMetodoChange(e.detail.value)}>
                    {(dadosEmpresa.configuracoesEntrega && dadosEmpresa.configuracoesEntrega.length > 0) && (
                      <IonSegmentButton
                        style={{ height: "30px" }} value="delivery">
                        <IonLabel style={{ fontSize: "14px" }}>Delivery</IonLabel>
                      </IonSegmentButton>
                    )}
                    {dadosEmpresa.retirada && (
                      <IonSegmentButton
                        style={{ height: "30px" }}
                        value="retirada"
                      >
                        <IonLabel style={{ fontSize: "14px" }}>Retirada</IonLabel>
                      </IonSegmentButton>
                    )}
                  </IonSegment>
                </IonToolbar>
              )}

              {/* TELA DE DELIVERY */}
              {deliveryMetodo === "delivery" && (modoDescoberta || dadosEmpresa?.configuracoesEntrega?.length > 0) ? (
                <>
                  {(modoDescoberta || dadosEmpresa.tipoConfiguracoesEntrega === "raio") ? (
                    <>
                      {/* Header com ilustração e texto */}
                      <div style={{
                        padding: '30px 20px',
                        textAlign: 'center',
                      }}>
                        <IonIcon
                          icon={locationOutline}
                          style={{
                            fontSize: '60px',
                            marginBottom: '15px'
                          }}
                        />
                        <h2 style={{
                          margin: '0 0 8px 0',
                          fontSize: '20px',
                          fontWeight: 'bold',
                          color: '#333'
                        }}>
                          Onde você quer receber seu pedido?
                        </h2>
                      </div>

                      {/* Campo de busca com ícone */}
                      <div style={{ padding: '0 16px 16px' }}>
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          backgroundColor: '#f5f5f5',
                          borderRadius: '12px',
                          padding: '4px 12px',
                          border: '1px solid #e0e0e0'
                        }}>
                          <IonIcon
                            icon={searchOutline}
                            style={{
                              fontSize: '20px',
                              color: '#999',
                              marginRight: '8px'
                            }}
                          />
                          <IonInput
                            ref={(ref) => props.inputRef.current = ref}
                            value={rua}
                            maxlength={70}
                            placeholder="Buscar endereço e número"
                            enterkeyhint="search"
                            autocorrect="on"
                            spellcheck={true}
                            onIonInput={(e: any) => {
                              const valor = e.target.value;
                              setRua(valor);
                              buscarSugestoesEndereco(valor);
                            }}
                            onKeyDown={(e: any) => {
                              if (e.key === 'Enter') {
                                e.preventDefault();
                                const valor = rua || '';
                                if (valor.trim().length >= 4) {
                                  buscarSugestoesEndereco(valor, true);
                                } else {
                                  setTextToast('Digite no mínimo 4 caracteres para buscar.');
                                  setShowToast(true);
                                }
                              }
                            }}
                            style={{
                              fontSize: '16px',
                              '--padding-start': '0',
                              '--padding-end': '0'
                            }}
                          ></IonInput>
                        </div>

                        {/* Powered by Google */}
                        <div style={{
                          textAlign: 'right',
                          marginTop: '8px',
                          paddingRight: '4px'
                        }}>
                          <span style={{
                            fontSize: '11px',
                            color: '#999',
                            fontWeight: '500'
                          }}>
                            powered by <span style={{ fontWeight: 'bold', color: '#4285F4' }}>G</span>
                            <span style={{ fontWeight: 'bold', color: '#EA4335' }}>o</span>
                            <span style={{ fontWeight: 'bold', color: '#FBBC04' }}>o</span>
                            <span style={{ fontWeight: 'bold', color: '#4285F4' }}>g</span>
                            <span style={{ fontWeight: 'bold', color: '#34A853' }}>l</span>
                            <span style={{ fontWeight: 'bold', color: '#EA4335' }}>e</span>
                          </span>
                        </div>
                      </div>

                      {/* Lista de sugestões embaixo */}
                      <IonList style={{
                        padding: "0",
                        margin: "0px"
                      }}>
                        {listaEnderecos?.length > 0 && listaEnderecos.map((item: any, index: any) => (
                          <IonItem
                            style={{
                              // padding: "12px 16px",
                              // margin: "0",
                              // borderBottom: index < listaEnderecos.length - 1 ? '1px solid #f1f1f1' : 'none',
                              // '--background': 'white'
                            }}
                            lines="none"
                            key={"sugestao" + index}
                            button
                            detail
                            onClick={() => handleSelectItem(item)}
                          >
                            <IonIcon
                              icon={locationOutline}
                              slot="start"
                              color='primary'
                              style={{
                                fontSize: '20px',
                                marginRight: '12px'
                              }}
                            />
                            <IonLabel style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                              <div style={{
                                fontWeight: '600',
                                fontSize: '15px',
                                marginBottom: '4px',
                                color: '#333'
                              }}>
                                {item.descricaoPrincipal}
                              </div>
                              <div style={{ fontSize: '13px', color: '#999' }}>
                                {item.descricaoSecundaria}
                              </div>
                            </IonLabel>
                          </IonItem>
                        ))}

                        {/* Item "Não achei meu endereço" */}
                        {ultimaBuscaRealizada && (
                          <IonItem
                            lines="none"
                            button
                            detail
                            onClick={() => {
                              setEtapaEndereco('enderecoManual');
                              setPulouEtapaNumero(true);
                            }}
                          >
                            <IonIcon
                              icon={searchOutline}
                              slot="start"
                              color='primary'
                              style={{
                                fontSize: '20px',
                                marginRight: '12px'
                              }}
                            />
                            <IonLabel style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                              <div style={{
                                fontWeight: '600',
                                fontSize: '15px',
                                marginBottom: '4px',
                                color: 'var(--ion-color-primary)',
                              }}>
                                Não achei meu endereço
                              </div>
                              <div style={{ fontSize: '13px', color: '#999' }}>
                                Buscar pelo mapa
                              </div>
                            </IonLabel>
                          </IonItem>
                        )}


                      </IonList>
                    </>
                  ) : (
                    // Interface para delivery por bairro
                    <>
                      {/* Header com ícone e título */}
                      <div style={{
                        padding: '30px 20px 10px',
                        textAlign: 'center',
                      }}>
                        <IonIcon
                          icon={locationOutline}
                          style={{
                            fontSize: '60px',
                            marginBottom: '15px'
                          }}
                        />
                        <h2 style={{
                          margin: '0 0 8px 0',
                          fontSize: '20px',
                          fontWeight: 'bold',
                          color: '#333'
                        }}>
                          Onde você quer receber seu pedido?
                        </h2>
                        <p style={{
                          margin: '0 0 0 0',
                          fontSize: '14px',
                          color: '#666',
                          lineHeight: '1.6'
                        }}>
                          Informe seu endereço completo
                        </p>
                      </div>

                      {/* Campos */}
                      <IonItem lines="none">
                        <IonLabel
                          position="stacked"
                          style={{ display: 'block', whiteSpace: 'normal', wordWrap: 'break-word', marginBottom: '8px' }}
                        >
                          Endereço*
                          {/*<small style={{ fontSize: '14px', color: '#666' }}>
                            (Informe o endereço completo)
                          </small>*/}
                        </IonLabel>
                        <IonInput
                          ref={(ref) => props.inputRef.current = ref}
                          value={enderecoBairro}
                          maxlength={70}
                          placeholder="Ex: Avenida Paulista, São Paulo, SP"
                          onIonInput={(e: any) => setEnderecoBairro(e.target.value)}
                        ></IonInput>
                      </IonItem>

                      <IonItem lines="none">
                        <IonLabel position="stacked">Número*</IonLabel>
                        <IonInput
                          type="tel"
                          value={numeroBairro}
                          maxlength={10}
                          placeholder="Digite o número"
                          disabled={enderecoSemNumeroBairro}
                          onIonInput={(e: any) => setNumeroBairro(e.target.value)}
                        ></IonInput>
                      </IonItem>

                      <IonItem lines="none">
                        <IonLabel>Endereço sem número</IonLabel>
                        <IonCheckbox
                          slot="end"
                          checked={enderecoSemNumeroBairro}
                          onIonChange={(e) => {
                            setEnderecoSemNumeroBairro(e.detail.checked);
                            if (e.detail.checked) {
                              setNumeroBairro('');
                            }
                          }}
                        />
                      </IonItem>

                      <IonItem lines="none">
                        <IonLabel position="stacked">Bairro*</IonLabel>
                        <IonSelect
                          placeholder="Selecione"
                          value={bairroSelecionado}
                          onIonChange={(e) => setBairroSelecionado(e.detail.value)}
                        >
                          {dadosEmpresa.configuracoesEntrega?.map((config: any, index: number) => (
                            <IonSelectOption key={index} value={config.bairro}>
                              {config.bairro}
                            </IonSelectOption>
                          ))}
                        </IonSelect>
                      </IonItem>

                      <IonItem lines="none">
                        <IonLabel position="stacked">Complemento</IonLabel>
                        <IonInput
                          value={complementoBairro}
                          maxlength={50}
                          placeholder="Complemento do endereço"
                          onIonInput={(e: any) => setComplementoBairro(e.target.value)}
                        ></IonInput>
                      </IonItem>
                    </>
                  )}
                </>
              ) : null}

              {/* TELA DE RETIRADA */}
              {deliveryMetodo === "retirada" && (
                <div style={{
                  padding: '30px 20px',
                  textAlign: 'center',
                }}>
                  <IonIcon
                    icon={storefrontOutline}
                    style={{
                      fontSize: '60px',
                      marginBottom: '15px'
                    }}
                  />
                  <h2 style={{
                    margin: '0 0 8px 0',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    color: '#333'
                  }}>
                    Retirada no Local
                  </h2>

                  {/* Descrição */}
                  <h2 style={{
                    margin: '0 0 30px 0',
                    fontSize: '16px',
                    color: '#666',
                  }}>
                    Seu pedido estará pronto para retirada no estabelecimento
                  </h2>



                  {dadosEmpresa?.empresaEndereco && (
                    <IonItem
                      style={{
                        // padding: "12px 16px",
                        // margin: "0",
                        // borderBottom: index < listaEnderecos.length - 1 ? '1px solid #f1f1f1' : 'none',
                        // '--background': 'white'
                      }}
                      lines="none"
                      key={"retirada"}
                    // button
                    // detail
                    // onClick={() => handleSelectItem(item)}
                    >
                      <IonIcon
                        icon={locationOutline}
                        slot="start"
                        color='primary'
                        style={{
                          fontSize: '20px',
                          marginRight: '12px'
                        }}
                      />
                      <IonLabel style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                        <div style={{
                          fontWeight: '600',
                          fontSize: '15px',
                          marginBottom: '4px',
                          color: '#333'
                        }}>
                          ENDEREÇO
                        </div>
                        <div style={{ fontSize: '13px', color: '#999' }}>
                          {dadosEmpresa?.empresaEndereco}
                        </div>
                      </IonLabel>
                    </IonItem>
                  )}



                </div>
              )}
            </>
          )}

          {/* ETAPA ENDEREÇO MANUAL: DIGITAR ENDEREÇO E NÚMERO */}
          {etapaEndereco === 'enderecoManual' && (
            <div style={{
              padding: '30px 20px',
              textAlign: 'center'
            }}>
              {/* Ícone */}
              <IonIcon
                icon={searchOutline}
                style={{
                  fontSize: '60px',
                  color: 'primary',
                  marginBottom: '15px'
                }}
              />

              {/* Título */}
              <h2 style={{
                margin: '0 0 8px 0',
                fontSize: '20px',
                fontWeight: 'bold',
                color: '#333'
              }}>
                Digite seu endereço
              </h2>

              {/* Descrição */}
              <p style={{
                margin: '0 0 30px 0',
                fontSize: '14px',
                color: '#666',
                lineHeight: '1.6'
              }}>
                Informe o endereço completo e depois ajuste a localização no mapa
              </p>

              {/* Card com campos */}
              <div style={{
                backgroundColor: '#f8f9fa',
                borderRadius: '12px',
                padding: '20px',
                maxWidth: '350px',
                width: '100%',
                marginLeft: 'auto',
                marginRight: 'auto'
              }}>
                {/* Campo de endereço */}
                <IonItem lines="none" style={{ '--background': 'transparent', '--padding-start': '0', marginBottom: '16px' }}>
                  <IonLabel position="stacked">Endereço</IonLabel>
                  <IonInput
                    value={enderecoManual}
                    placeholder="Rua, avenida..."
                    maxlength={100}
                    onIonInput={(e: any) => setEnderecoManual(e.target.value)}
                  ></IonInput>
                </IonItem>

                {/* Campo de número */}
                <IonItem lines="none" style={{ '--background': 'transparent', '--padding-start': '0', marginBottom: '16px' }}>
                  <IonLabel position="stacked">Número</IonLabel>
                  <IonInput
                    type="tel"
                    value={numeroManual}
                    placeholder="Digite o número"
                    disabled={enderecoSemNumero}
                    onIonInput={(e: any) => setNumeroManual(e.target.value)}
                    style={{
                      fontSize: '24px',
                      textAlign: 'center',
                      fontWeight: 'bold'
                    }}
                  ></IonInput>
                </IonItem>

                {/* Checkbox "Endereço sem número" */}
                <IonItem lines="none" style={{ '--background': 'transparent', '--padding-start': '0' }}>
                  <IonLabel>Endereço sem número</IonLabel>
                  <IonCheckbox
                    slot="end"
                    checked={enderecoSemNumero}
                    onIonChange={(e) => {
                      setEnderecoSemNumero(e.detail.checked);
                      if (e.detail.checked) {
                        setNumeroManual('');
                      }
                    }}
                  />
                </IonItem>
              </div>
            </div>
          )}

          {/* ETAPA 2: INFORMAR NÚMERO */}
          {etapaEndereco === 'numero' && (
            <div style={{
              padding: '30px 20px',
              textAlign: 'center'
            }}>
              {/* Ícone */}
              <IonIcon
                icon={locationOutline}
                style={{
                  fontSize: '60px',
                  color: 'primary',
                  marginBottom: '15px'
                }}
              />

              {/* Título */}
              <h2 style={{
                margin: '0 0 8px 0',
                fontSize: '20px',
                fontWeight: 'bold',
                color: '#333'
              }}>
                Digite o número
              </h2>

              {/* Descrição do endereço */}
              <p style={{
                margin: '0 0 30px 0',
                fontSize: '14px',
                color: '#666',
                lineHeight: '1.6',
                maxWidth: '300px',
                marginLeft: 'auto',
                marginRight: 'auto',
                wordWrap: 'break-word',
                overflowWrap: 'break-word'
              }}>
                {descricaoEnderecoSelecionado}
              </p>

              {/* Card com campo de número */}
              <div style={{
                backgroundColor: '#f8f9fa',
                borderRadius: '12px',
                padding: '20px',
                maxWidth: '350px',
                width: '100%',
                marginLeft: 'auto',
                marginRight: 'auto'
              }}>
                {/* Campo de número */}
                <IonItem lines="none" style={{ '--background': 'transparent', '--padding-start': '0', marginBottom: '16px' }}>
                  <IonLabel position="stacked">Número</IonLabel>
                  <IonInput
                    type="tel"
                    value={numeroEndereco}
                    placeholder="Digite o número"
                    disabled={enderecoSemNumero}
                    onIonInput={(e: any) => setNumeroEndereco(e.target.value)}
                    style={{
                      fontSize: '24px',
                      textAlign: 'center',
                      fontWeight: 'bold'
                    }}
                  ></IonInput>
                </IonItem>

                {/* Checkbox "Endereço sem número" */}
                <IonItem lines="none" style={{ '--background': 'transparent', '--padding-start': '0' }}>
                  <IonLabel>Endereço sem número</IonLabel>
                  <IonCheckbox
                    slot="end"
                    checked={enderecoSemNumero}
                    onIonChange={(e) => {
                      setEnderecoSemNumero(e.detail.checked);
                      if (e.detail.checked) {
                        setNumeroEndereco('');
                      }
                    }}
                  />
                </IonItem>
              </div>
            </div>
          )}

          {/* ETAPA 3: CONFIRMAR NO MAPA */}
          {/* {etapaEndereco === 'mapa' && (
            <div style={{ textAlign: 'center', padding: '20px', backgroundColor: 'white' }}>
              <h3 style={{ margin: '0 0 10px 0', fontSize: '18px' }}>Você está aqui?</h3>
              <p style={{ margin: 0, color: '#666', fontSize: '14px' }}>Ajuste a localização</p>
            </div>
          )} */}

          {/* ETAPA 4: COMPLEMENTO */}
          {etapaEndereco === 'complemento' && (
            <div style={{
              padding: '30px 20px',
              textAlign: 'center'
            }}>
              {/* Ícone */}
              <IonIcon
                icon={locationOutline}
                style={{
                  fontSize: '60px',
                  color: 'primary',
                  marginBottom: '15px'
                }}
              />

              {/* Título */}
              <h2 style={{
                margin: '0 0 8px 0',
                fontSize: '20px',
                fontWeight: 'bold',
                color: '#333'
              }}>
                Complemento do endereço
              </h2>

              {/* Descrição do endereço */}
              <p style={{
                margin: '0 0 30px 0',
                fontSize: '14px',
                color: '#666',
                lineHeight: '1.6',
                maxWidth: '300px',
                marginLeft: 'auto',
                marginRight: 'auto',
                wordWrap: 'break-word',
                overflowWrap: 'break-word'
              }}>
                {descricaoEnderecoSelecionado}{numeroEndereco ? `, ${numeroEndereco}` : ''}
              </p>

              {/* Card com campo de complemento */}
              <div style={{
                backgroundColor: '#f8f9fa',
                borderRadius: '12px',
                padding: '20px',
                maxWidth: '350px',
                width: '100%',
                marginLeft: 'auto',
                marginRight: 'auto'
              }}>
                <IonItem lines="none" style={{ '--background': 'transparent', '--padding-start': '0', marginBottom: '16px' }}>
                  <IonLabel position="stacked">Complemento</IonLabel>
                  <IonInput
                    value={complemento}
                    maxlength={50}
                    placeholder="Apartamento, bloco, casa..."
                    disabled={enderecoSemComplemento}
                    onIonInput={(e: any) => setComplemento(e.target.value)}
                  ></IonInput>
                </IonItem>

                {/* Checkbox "Sem complemento" */}
                <IonItem lines="none" style={{ '--background': 'transparent', '--padding-start': '0' }}>
                  <IonLabel>Endereço sem complemento</IonLabel>
                  <IonCheckbox
                    slot="end"
                    checked={enderecoSemComplemento}
                    onIonChange={(e) => {
                      setEnderecoSemComplemento(e.detail.checked);
                      if (e.detail.checked) {
                        setComplemento('');
                      }
                    }}
                  />
                </IonItem>

                {/* Informação adicional */}
                {/* <p style={{
                  fontSize: '12px',
                  color: '#999',
                  marginTop: '12px',
                  marginBottom: '0',
                  textAlign: 'left',
                  paddingLeft: '0'
                }}>
                  Exemplo: Apto 123, Bloco A, Casa 2
                </p> */}
              </div>
            </div>
          )}

        </div>

        <div style={{
          position: "relative",
          width: "100%",
          height: "100%",
          opacity: (etapaEndereco === 'mapa' || etapaEndereco === 'complemento') ? 1 : 0,
          pointerEvents: etapaEndereco === 'mapa' ? 'auto' : 'none'
        }}>
          <div id="map" style={{ width: "100%", height: "100%" }}></div>

          {/* Pin fixo no centro do mapa */}
          {etapaEndereco === 'mapa' && (
            <div style={{
              position: 'absolute',
              top: '50%', // Compensar footer
              left: '50%',
              zIndex: 1000,
              pointerEvents: 'none',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '8px',
              transform: 'translate(-50%, -100%)' // Move tudo para cima para a ponta do pin ficar no centro
            }}>
              {/* Popup de instrução acima do pin */}
              <div style={{
                background: 'white',
                padding: '12px 16px',
                borderRadius: '8px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                textAlign: 'center',
                minWidth: '180px',
                whiteSpace: 'nowrap'
              }}>
                <p style={{ margin: '0 0 4px 0', fontSize: '14px', fontWeight: 'bold', color: '#333' }}>
                  Você está aqui?
                </p>
                <p style={{ margin: '0', fontSize: '12px', color: '#666' }}>
                  Ajuste a localização
                </p>
              </div>

              {/* Pin */}
              <img
                src="/assets/pin.svg"
                alt="Pin"
                style={{
                  width: '40px',
                  height: '40px',
                  filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))',
                  display: 'block'
                }}
              />
            </div>
          )}
        </div>

      </IonContent>
      <IonFooter className="ion-no-border">
        <IonToolbar style={{ padding: '10px' }}>

          {/* Botões baseados na etapa */}
          {etapaEndereco === 'enderecoManual' && (
            <IonButton size='large' onClick={() => confirmarEnderecoManual()} expand="block" type="submit">
              Continuar
            </IonButton>
          )}

          {etapaEndereco === 'numero' && (
            <IonButton size='large' onClick={() => confirmarNumero()} expand="block" type="submit">
              Continuar
            </IonButton>
          )}

          {etapaEndereco === 'mapa' && (
            <IonButton size='large' onClick={() => confirmarLocalizacao()} expand="block" type="submit">
              Confirmar localização
            </IonButton>
          )}

          {etapaEndereco === 'complemento' && (
            <IonButton size='large' onClick={() => cadastrar()} expand="block" type="submit">
              Finalizar
            </IonButton>
          )}

          {etapaEndereco === 'busca' && deliveryMetodo === 'retirada' && (
            <IonButton size='large' onClick={() => {
              props.closeAction("RETIRADA", "", "", "", "", "");
            }} expand="block" type="submit">
              Continuar
            </IonButton>
          )}

          {etapaEndereco === 'busca' && deliveryMetodo === 'delivery' && dadosEmpresa.tipoConfiguracoesEntrega === "bairro" && (
            <IonButton size='large' onClick={() => {
              if (!enderecoBairro.trim()) {
                setTextToast("Endereço é obrigatório.");
                setShowToast(true);
                return;
              }
              if (!enderecoSemNumeroBairro && !numeroBairro.trim()) {
                setTextToast('Por favor, informe o número ou marque "Endereço sem número".');
                setShowToast(true);
                return;
              }
              if (!bairroSelecionado) {
                setTextToast("Selecione um bairro.");
                setShowToast(true);
                return;
              }

              // Montar endereço completo com número
              const enderecoCompletoComNumero = enderecoSemNumeroBairro
                ? enderecoBairro
                : `${enderecoBairro}, ${numeroBairro}`;

              const bairroConfig = dadosEmpresa.configuracoesEntrega?.find((config: any) => config.bairro === bairroSelecionado);
              if (bairroConfig) {
                props.closeAction(enderecoCompletoComNumero + (bairroSelecionado ? `, ${bairroSelecionado}` : ""), "", "", bairroConfig.taxa, bairroConfig.tempo, complementoBairro);
              } else {
                setTextToast("Bairro não encontrado na configuração.");
                setShowToast(true);
              }
            }} expand="block" type="submit">
              Continuar
            </IonButton>
          )}

        </IonToolbar>
      </IonFooter>

      <IonToast
        isOpen={showToast}
        position="middle"
        onDidDismiss={() => setShowToast(false)}
        message={textToast}
        duration={3000}
      />


      <IonLoading
        cssClass='my-custom-class'
        isOpen={showLoading}
        onDidDismiss={() => { setShowLoading(false); }}
        spinner='circles'
      />

    </>
  );
};

export default ({ endereco, inputRef, closeAction, closeActionSimple, modoDescoberta = false }: Props) => (
  <Endereco
    endereco={endereco}
    inputRef={inputRef}
    closeAction={closeAction}
    closeActionSimple={closeActionSimple}
    modoDescoberta={modoDescoberta}
  >
  </Endereco>
)
